import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { useTheme } from '@mui/material';

const Skype: React.FC<IconProps> = ({ size, style, color, secondaryColor }) => {
  const theme = useTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      width={size ?? '200'}
      height={size ?? '200'}
      version="1.1"
      viewBox="0 0 21 21"
      data-testid="skype-icon"
    >
      <path
        fill={color ?? '#03a9f4'}
        strokeWidth="0.494"
        d="M10.539.66C5.105.66.66 5.105.66 10.539c0 5.433 4.445 9.879 9.879 9.879 5.433 0 9.879-4.446 9.879-9.88 0-5.433-4.446-9.878-9.88-9.878z"
      />
      <circle cx="15.231" cy="15.231" r="5.68" fill={color ?? '#03a9f4'} strokeWidth="0.494" />
      <circle cx="5.846" cy="5.846" r="5.68" fill={color ?? '#03a9f4'} strokeWidth="0.494" />
      <path
        fill={color ? secondaryColor || theme.palette.primary.main : '#fff'}
        strokeWidth="0.494"
        d="M10.835 16.466c-3.26 0-4.742-1.63-4.742-2.865 0-.642.445-1.087 1.087-1.087 1.383 0 1.037 2.026 3.655 2.026 1.334 0 2.075-.741 2.075-1.482 0-.445-.198-.939-1.087-1.186l-2.914-.74c-2.322-.593-2.766-1.877-2.766-3.112 0-2.52 2.321-3.409 4.495-3.409 2.025 0 4.346 1.087 4.346 2.569 0 .642-.494 1.037-1.136 1.037-1.185 0-.988-1.68-3.359-1.68-1.185 0-1.877.544-1.877 1.334s.939 1.038 1.779 1.235l2.173.494c2.37.544 2.914 1.927 2.914 3.26-.05 2.075-1.531 3.606-4.643 3.606z"
      />
    </svg>
  );
};

export default Skype;
